document.getElementById("dismiss-age-consent-btn").addEventListener("click", function() {
    dismissAgeConsent()
})

function dismissAgeConsent() {
    document.cookie = "ageconsent_status=dismissed;expires=Thu, 31 Dec 2037 23:59:59 UTC;path=/";
    document.getElementById("age-consent-banner").remove();
    document.getElementsByTagName("body")[0].style.overflow = "visible";
}

document.getElementsByTagName("body")[0].style.overflow = "hidden";